import dayjs from "dayjs";

export function buildCalendar(month: dayjs.Dayjs) {
  const firstDay = month.startOf("month");
  const mondayOffset = (firstDay.day() + 6) % 7;
  const start = firstDay.subtract(mondayOffset, "day");
  return Array.from({ length: 42 }, (_, index) => {
    const date = start.add(index, "day");
    return { date, inMonth: date.month() === month.month(), key: date.format("YYYY-MM-DD") };
  });
}
